import component from './BackHeader';

export default component;
